import Icon from '@ant-design/icons';
import classNames from 'classnames';
import { memo } from 'react';

import rightSvg from '@/components/Icon/svgs/right_button.svg';
import HelpIframe from '@/components/help-iframe';

import styles from './index.less';

interface IProps
  extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
  url?: string;
  className?: string;
}

function LearnMore(props: IProps): JSX.Element | null {
  const { url, className } = props;

  if (!url) {
    return null;
  }

  return (
    <HelpIframe className={classNames(styles.helpIframe, className)} url={url}>
      Learn more
      <Icon className={styles.icon} component={rightSvg} />
    </HelpIframe>
  );
}

export default memo(LearnMore);
